import { CostProfileCostsHistory } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeCost(httpClient: HttpClient) {
  return ({ uuid }: CostProfileCostsHistory[number]) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/costProfileHistories/${uuid}`,
      method: HttpMethods.DELETE,
    });
}

export { removeCost };
